<lcp-header *ngIf="fields" [isInverted]="!!fields['bannerColor']"></lcp-header>

<div class="main-content-container padding-bottom-0">
  <ng-container *ngIf="fields">
    <section [ngClass]="[
        'lcp-section', 
        !!fields['bannerColor'] ? 'is-banner' : '',
        fields['bannerColor'] ? 'is-background-' + fields['bannerColor'] : ''
      ]">

      <div class="lcp-section-content">
        <div class="display-flex">
          <h1 *ngIf="fields['title']" class="section-title margin-top-20 margin-bottom-80 flex-50-not-sm">
            {{ fields['title'] }}
          </h1>
        </div>
      </div>
    </section>

    <section class="lcp-section">
      <div class="lcp-section-content">
        <div class="projects-filters-container">
          <!-- {{ tags | json }} -->
          <div class="lcp-filters">
            <!-- <a href="/projects" -->
            <!-- <a class="lcp-filter-group"
              [class.is-active]="activeFilters.length == 0"
              (click)="handleSelectFilterGroup(null)">
              all
            </a> -->

            <ng-container *ngFor="let filterGroup of filterGroups">
              <div *ngIf="filterGroup" class="lcp-filter-group"
                [class.is-active]="filterGroup.isActive || (activeFilters.length == 0 && !filterGroup.fields['items'])"
                [class.is-open]="filterGroup.isOpen"
                (click)="handleSelectFilterGroup(filterGroup)"
                [innerHtml]="lcpHelper.htmlFromRichText(filterGroup.fields['display'])">
              </div>
            </ng-container>
          </div>

          <div *ngIf="activeFilterGroup"
            class="lcp-filters">
            <a *ngFor="let filter of activeFilterGroup.fields['items']"
              class="lcp-filter"
              [class.is-active]="filterIsActive(filter)"
              (click)="handleSelectFilter(filter)" >

              {{ filter.fields['display'] }}
            </a>
          </div>
        </div>

        <div #projectsSizing class="projects-container projects-container-sizing">
          <section class="project" *ngFor="let project of projects">
            <div class="project-placeholder"></div>
          </section>
        </div>

        <div #projectsContainerOuter class="projects-container-outer">

          <div class="projects-container"
            [class.is-hidden]="!showProjects">
            <section class="project" *ngFor="let project of projects; index as projectIndex">
              <!-- [class.size-lg]="project.fields['size'] == 'large'"> -->
              <!-- <p><code>{{ project | json }}</code></p> -->
              
              <a class="project-preview-container"
                [class.is-missing-image]="!project.metadata['src']"
                [routerLink]="projectPath(project)">

                <div class="project-preview-image-container">
                  <!-- {{ projectPath(project) }} -->
                  <!-- <div *ngIf="!project.metadata['src']"
                    class="img-placeholder">
                  </div> -->

                  <img *ngIf="project.metadata['src']"
                  class="project-preview-cover-image"
                  [src]="project.metadata['src']"
                  [attr.srcset]="lcpHelper.srcsetFromMedia(project.fields['media'][0])"
                  sizes="(min-width: 800px) 50vw, 100vw"
                  [attr.loading]="projectIndex >= 4 ? 'lazy' : null"
                  height="380px"
                  width="680px">

                  <!-- <div *ngIf="!project.metadata['src']"
                  class="project-preview-image-placeholder"
                  height="380px"
                  width="635px">
                  </div> -->

                  <!-- [src]="urlFromMedia(project.fields['media'][0])" -->


                  <div class="project-preview-overlay">
                    <div class="project-preview-overlay-content">
                      <div class="flex-10a"></div>
                      <div class="project-preview-overlay-title">
                        {{ project.fields['title'] }}
                      </div>
                      <div class="project-preview-overlay-tagline txt-lowercase"
                        *ngIf="project.fields['tagline']"
                        [innerHtml]="lcpHelper.htmlFromRichText(project.fields['tagline'])">
                        <!-- [innerHtml]="project.metadata['innerHTML']"> -->
                        <!-- {{ project.fields['tagline'] }}</div> -->
                      </div>
                    </div>
                  </div>
                </div>

                <div class="project-preview-title-sm hover-after">
                  {{ project.fields['title'] }}
                </div>
              </a>
            </section>

            <section *ngIf="!projects || projects.length == 0"
              class="lcp-placeholder"
              [innerHTML]="placeholder">

              <div
                class="img-placeholder">
              </div>
            </section>
          </div>
        </div>
      </div>
      
    </section>
  </ng-container>
</div>